<epay-page-content [pagetitle]="pagetitle">
  <div class="box-panel shadow max-w max-gs">
    <div class="">
      <h2 class="mb-1" style="text-align: center;">Contact Information</h2>
      <br>
      <div class="mx-3">
        <h3>Customer Service Telephone</h3>
        1-855-363-1753
      </div>
    </div>
  </div>
</epay-page-content>
